import { render, staticRenderFns } from "./newsShowModule.vue?vue&type=template&id=62a391b6&"
import script from "./newsShowModule.vue?vue&type=script&lang=js&"
export * from "./newsShowModule.vue?vue&type=script&lang=js&"
import style0 from "./newsShowModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports